<template>
  <div class="goToTemperHumidity">
    <ChartBox
      :title="shop_name.includes('鑫晟') ? ' 物联网设备监控' : '温湿度监控'"
      :tip="true"
    >
      <div class="double-column-layout">
        <!-- 温湿度列 -->
        <transition name="el-fade-in">
          <el-table
            :data="temperatureData"
            style="width: 100%; height: 230px"
            v-if="activeTable === 'temperature' && temperatureData.length"
          >
            <el-table-column
              label="温湿度实时监控"
              align="center"
              header-align="center"
            >
              <template #header>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                    @click="handleHelp()"
                >
                  <span>温湿度实时监控</span>
                  <i
                    class="el-icon-info"
                    style="margin-left: 5px; cursor: pointer"
                    title="帮助信息"
                  ></i>
                </div>
              </template>

              <el-table-column
                prop="name"
                label="地点"
                align="center"
              ></el-table-column>

              <!-- 温度列 -->
              <el-table-column label="温度" align="center">
                <template #header>
                  <div
                    class="header-with-icon"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <span>温度</span>
                    <img
                      src="../assets/image/wendu.png"
                      class="header-icon"
                      style="width: 15px; height: 17px; margin-left: 2px"
                    />
                  </div>
                </template>
                <template #default="{ row }">
                  <div v-if="row.temp">
                    <span
                      style="font-weight: bold"
                      :style="{ color: getStatusColor(row.temp_status) }"
                      >{{ row.temp }}℃</span
                    >
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>

              <!-- 湿度列 -->
              <el-table-column label="湿度" align="center">
                <template #header>
                  <div
                    class="header-with-icon"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <span>湿度</span>
                    <img
                      src="../assets/image/shidu.png"
                      class="header-icon"
                      style="width: 15px; height: 15px; margin-left: 2px"
                    />
                  </div>
                </template>
                <template #default="{ row }">
                  <div v-if="row.wet">
                    <span
                      v-if="row.wet > 0"
                      style="font-weight: bold"
                      :style="{ color: getStatusColor(row.temp_status) }"
                      >{{ row.wet }}%</span
                    >
                    <span v-else>-</span>
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </transition>

        <!-- 燃气列 -->
        <transition name="el-fade-in">
          <el-table
            :data="gasData"
            style="width: 100%; height: 230px"
            v-if="activeTable === 'gas' && gasData.length"
          >
            <el-table-column
              label="燃气实时监控"
              align="center"
              header-align="center"
            ><template #header>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                    @click="handleHelp2()"
                >
                  <span>燃气实时监控</span>
                  <i
                    class="el-icon-info"
                    style="margin-left: 5px; cursor: pointer"
                    title="帮助信息"
                  ></i>
                </div>
              </template>
              <el-table-column
                prop="name"
                label="地点"
                width=""
                align="center"
              ></el-table-column>
              <el-table-column label="数值" align="center">
                <template #header>
                  <div
                    class="header-with-icon"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <span>数值</span>
                    <img
                      src="../assets/image/jiawan.png"
                      class="header-icon"
                      style="width: 15px; height: 15px; margin-left: 2px"
                    />
                  </div>
                </template>
                <template #default="{ row }">
                  <div>
                    <span
                      style="font-weight: bold"
                      :style="{ color: getStatusColor(row.status) }"
                      >{{ row.val }} %LEL</span
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </transition>

        <!-- 烟雾列 -->
        <transition name="el-fade-in">
          <el-table
            :data="smogData"
            style="width: 100%; height: 230px"
            v-if="activeTable === 'smog' && smogData.length"
          >
            <el-table-column
              label="烟雾实时监控"
              align="center"
              header-align="center"
            >
              <template #header>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                    @click="handleHelp3()"
                >
                  <span>烟雾浓度实时监控</span>
                  <!-- <i
                    class="el-icon-info"
                    style="margin-left: 5px; cursor: pointer"
                    title="帮助信息"
                  ></i> -->
                </div>
              </template>
              <el-table-column
                prop="name"
                label="地点"
                width=""
                align="center"
              ></el-table-column>
              <el-table-column label="数值" align="center">
                <template #header>
                  <div
                    class="header-with-icon"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <span>数值</span>
                    <!-- <img
                      src="../assets/image/smog.png"
                      class="header-icon"
                      style="width: 15px; height: 15px; margin-left: 2px"
                    /> -->
                  </div>
                </template>
                <template #default="{ row }">
                  <div>
                    <span
                      style="font-weight: bold"
                      :style="{ color: getStatusColor(row.status) }"
                      >{{ row.val }} {{ row.val_unit || 'PPM' }}</span
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="空气质量" align="center">
                <template #header>
                  <div
                    class="header-with-icon"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <span>空气质量</span>
                  </div>
                </template>
                <template #default="{ row }">
                  <div>
                    <span
                      style="font-weight: bold"
                      :style="{ color: getSmogStatusColor(row.tips) }"
                      >{{ row.tips || '-' }}</span
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </transition>

        <div class="next" @click="nextPage">
          <img src="../assets/image/next2.png" alt="" />
        </div>
        <div class="prev" @click="nextPage">
          <img src="../assets/image/prev.png" alt="" />
        </div>
      </div>
    </ChartBox>
    <el-dialog
      title="温湿度范围说明"
      :visible.sync="dialogVisible"
      width="500px"
      center
    >
      <div class="range-table">
        <div style="display: flex;align-items: center;margin-bottom: 20px;"> 
          <h3 style="">温度范围说明 </h3>
          <img src="../assets/image/temps.png" style="width: 26px;margin-left: 5px;">
        </div>
       
        <table class="simple-table">
          <thead>
            <tr>
              <th>位置</th>
              <th>正常区间</th>
              <th>警告区间</th>
              <th>报警区间</th>
            </tr>
          </thead>
           <tbody>
            <tr>
              <td>干调库/粮油库</td>
              <!-- <td>25℃以下</td>
              <td>25℃ - 30℃</td>
              <td>> 30℃</td> -->
               <td>30℃以下</td>
              <td>30℃ - 32℃</td>
              <td>> 32℃</td>
            </tr>
            <tr>
              <td>冷藏库</td>
              <td>0℃ - 8℃</td>
              <td>8℃ - 10℃</td>
              <td>> 10℃</td>
            </tr>
            <tr>
              <td>冷冻库</td>
              <td> ≤-18℃</td>
              <td>-18℃  ~ -15℃</td>
              <td>>-15℃</td>
            </tr>
          </tbody>
        </table>
        <div style="display: flex;align-items: center;margin-bottom: 20px;margin-top: 20px;"> 
          <h3 style="">湿度范围说明 </h3>
          <img src="../assets/image/wet.png" style="width: 25px;margin-left: 5px;">
        </div>
        <table class="simple-table">
          <thead>
            <tr>
              <th>位置</th>
              <th>正常区间</th>
              <th>警告区间</th>
              <th>报警区间</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>干调库/粮油库</td>
              <!-- <td>65%以下</td> -->
               <td>75%以下</td>
              <!-- <td>65% - 80%</td> -->
               <td>75% - 80%</td>
              <td>> 80%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
    
    <el-dialog
      title="甲烷监测范围说明"
      :visible.sync="dialogVisible2"
      width="500px"
      center
    >
      <div class="range-table">
        <!-- <h3 style="margin-bottom: 20px">燃气监测范围说明</h3> -->
        <table class="simple-table">
          <thead>
            <tr>
              <th>类型</th>
              <th>正常区间</th>
              <th>警告区间</th>
              <th>报警区间</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>甲烷 <i class="el-icon-fire"></i></td>
              <td>0 %LEL</td>
              <td> 2%LEL - 5%LEL</td>
              <td>> 5%LEL</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>

    <el-dialog
      title="烟雾监测范围说明"
      :visible.sync="dialogVisible3"
      width="500px"
      center
    >
      <div class="range-table">
        <table class="simple-table">
          <thead>
            <tr>
              <th>类型</th>
              <th>正常区间</th>
              <th>警告区间</th>
              <th>报警区间</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>烟雾 <i class="el-icon-warning"></i></td>
              <td>空气质量：优</td>
              <td>空气质量：良</td>
              <td>空气质量：差</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ChartBox from "../components/chartBox.vue";
import { getIotInfoV2 } from "../api/api";
import { baseImgUrl } from "../utils/request";
// 引入混入
import { myMixin } from "../common/common.js";

export default {
  data() {
    return {
      temperatureData: [], // 温湿度数据
      gasData: [], // 燃气数据（甲烷/可燃气体）
      smogData: [], // 烟雾数据
      activeTable: "temperature", // 当前显示表格
      tableSequence: [], // 有数据可轮播的表格类型
      timer: null,
      cleanUpMemory: null,
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false
    };
  },
  components: {
    ChartBox,
  },
  mixins: [myMixin],
  mounted() {
    this.getIotInfoV();
    this.startCarousel();
    this.cleanUpMemory = setInterval(() => {
      this.getIotInfoV();
      this.startCarousel();
    }, 15 * 60 * 1000);
  },
  beforeDestroy() {
    this.stopCarousel();
  },
  methods: {
    handleHelp() {
      this.dialogVisible = true;
    },
    handleHelp2() {
      this.dialogVisible2 = true;
    },
    handleHelp3() {
      this.dialogVisible3 = true;
    },
    nextPage() {
      const seq = this.tableSequence;
      if (!seq.length) return;
      const idx = seq.indexOf(this.activeTable);
      this.activeTable = seq[(idx + 1) % seq.length];
    },
    // 获取地点
    async getIotInfoV() {
      const res = await getIotInfoV2();
      var newArr = [];
      if (res.data.data.temp && res.data.data.temp.length > 0) {
        newArr = [...res.data.data.temp];
      }
      if (res.data.data.jiawan && res.data.data?.jiawan.length > 0) {
        newArr = [...newArr, ...res.data.data?.jiawan];
      }
      if (res.data.data.smog && res.data.data?.smog.length > 0) {
        newArr = [...newArr, ...res.data.data.smog];
      }
      this.locationTempList = newArr;
      this.processData(this.locationTempList);

      console.log(this.locationTempList, "this.locationTempList");
    },
    // 数据处理方法
    processData(list) {
      console.log(list,'温度');

      this.temperatureData = list
        .filter((item) => "temp" in item || "wet" in item)
        .slice(0, 5); // 最多显示5条

      // 燃气数据：有 status 和 val，但没有 tips 字段
      this.gasData = list
        .filter((item) => "status" in item && "val" in item && !("tips" in item))
        .slice(0, 5); // 最多显示5条

      // 烟雾数据：有 status、val 和 tips 字段
      this.smogData = list
        .filter((item) => "status" in item && "val" in item && "tips" in item)
        .slice(0, 5); // 最多显示5条

      this.syncTables();
    },
    // 根据是否有数据，生成可轮播的表格序列；并修正当前展示为第一个有数据的类型
    syncTables() {
      const seq = [];
      if (this.temperatureData.length) seq.push("temperature");
      if (this.gasData.length) seq.push("gas");
      if (this.smogData.length) seq.push("smog");
      this.tableSequence = seq;
      if (seq.length && !seq.includes(this.activeTable)) {
        this.activeTable = seq[0];
      }
    },
    startCarousel() {
      this.timer = setInterval(() => {
        const seq = this.tableSequence;
        if (!seq.length) return;
        const idx = seq.indexOf(this.activeTable);
        this.activeTable = seq[(idx + 1) % seq.length];
      }, 10000); // 10秒切换
    },
    stopCarousel() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 状态颜色映射
    getStatusColor(status) {
      const colorMap = {
        正常: "#008000",
        警告: "#ffa500",
        报警: "#ff0000",
      };
      return colorMap[status] || "#606266"; // 默认返回Element默认颜色
    },
    // 烟雾状态颜色映射
    getSmogStatusColor(tips) {
      if (!tips) return "#606266";
      if (tips.includes("优")) return "#008000";
      if (tips.includes("良")) return "#ffa500";
      if (tips.includes("差")) return "#ff0000";
      return "#606266";
    },
  },
  beforeDestroy() {
    clearInterval(this.cleanUpMemory);
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
  background-color: #e4f1fe;
  font-weight: bold;
}
.simple-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
.simple-table th,
.simple-table td {
  border: 1px solid #ebeef5;
  padding: 12px 10px;
  text-align: center;
}
.simple-table th {
  background-color: #f5f7fa;
  color: #303133;
}
.double-column-layout {
  display: flex;
  justify-content: space-between;
  position: relative;
  .next {
    position: absolute;
    top: 100px;
    right: 0px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    // background: rgba(24, 144, 255, 0.35) !important;
    backdrop-filter: blur(2px);
    border: 2px solid #6c7a89;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 999;
    img {
      width: 12px;
      height: 12px;
    }
  }
  .next:hover {
    background: rgba(24, 144, 255, 0.9) !important;
    box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
  }
  .prev {
    position: absolute;
    top: 100px;
    left: 0px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    // background: rgba(24, 144, 255, 0.35) !important;
    backdrop-filter: blur(2px);
    border: 2px solid #6c7a89;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    img {
      width: 12px;
      height: 12px;
    }
  }
  .prev:hover {
    background: rgba(24, 144, 255, 0.9) !important;
    box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
  }
}

::v-deep .el-table__header-wrapper {
  background-color: #01345c;
}
::v-deep .el-table thead.is-group th.el-table__cell {
  border: none !important;
  background-color: #01173d !important;
  color: white !important;
  font-size: 16px;
}

.el-table th {
  font-weight: 600;
  color: #303133;
}

.double-column-layout ::v-deep .el-table th.el-table__cell.is-leaf {
  padding: 6px 0 !important;
  background-color: #021331 !important;
  color: white !important;
  border: none !important;
  font-size: 14px;
}
.double-column-layout ::v-deep .el-table td.el-table__cell {
  padding: 4px 0 !important;
  background-color: #011431 !important;
  color: #999 !important;
  border: none !important;
  font-size: 14px;
}
.double-column-layout ::v-deep .el-table {
  transform: scale(1) !important;
  width: 100% !important;
  margin-left: 0px !important;
  border: 1px solid #011431 !important;
  background-color: #011431;
}

::v-deep .el-table--border::after,
.el-table--group::after {
  width: 0px !important;
}
::v-deep .el-table::before {
  height: 0px !important;
}
</style>
<style>
.v-modal {
  background-color: rgba(0, 0, 0, 0.8) !important;
  opacity: 1 !important;
  z-index: 2 !important;
}
</style>
